// Adapter utilities to normalize backend row shapes into a stable frontend shape
export function normalizeBannerRow(row: any) {
  if (!row || typeof row !== 'object') return row;

  const symbolRaw = row.symbol ?? row.ticker ?? row.asset ?? '';
  const symbol = String(symbolRaw || '').toUpperCase();

  const currentPrice = row.current_price ?? row.price ?? row.last_price ?? null;
  const priceChange1h = row.price_change_1h ?? row.price_change_percentage_1h ?? row.pct_change_1h ?? row.change_pct ?? null;

  const volumeNow = Number(row.volume_1h ?? row.volume ?? 0) || 0;

  let volumeChangePct: number | null = null;
  if (row.volume_change_1h_pct != null && !Number.isNaN(Number(row.volume_change_1h_pct))) {
    volumeChangePct = Number(row.volume_change_1h_pct);
  }

  const isEstimated = Boolean(row.volume_change_is_estimated);

  return {
    // canonical fields used across UI
    symbol,
    originalSymbol: symbolRaw,
    currentPrice: currentPrice == null ? null : Number(currentPrice),
    priceChange1h: priceChange1h == null ? null : Number(priceChange1h),
    volumeNow,
    volumeChangePct: volumeChangePct == null ? null : Number(volumeChangePct),
    volumeChangeIsEstimated: isEstimated,
    // keep raw for debugging
    _raw: row,
  };
}

export function normalizeTableRow(row: any) {
  // Reuse banner normalizer as table rows are similar; add rank if present
  const base = normalizeBannerRow(row);
  return {
    ...base,
    rank: row.rank ?? row.position ?? null,
    trendDirection: row.trend_direction ?? row.trendDirection ?? null,
    trendScore: row.trend_score ?? row.trendScore ?? null,
    trendStreak: row.trend_streak ?? row.trendStreak ?? null,
  };
}

export default { normalizeBannerRow, normalizeTableRow };
